// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import HelloController from './hello_controller'
import MediamtxController from './mediamtx_controller'
import RansackFormController from './ransack_form_controller'
import TextTruncateController from './text_truncate_controller'
import TooltipController from './tooltip_controller'

application.register('hello', HelloController)
application.register('mediamtx', MediamtxController)
application.register('ransack-form', RansackFormController)
application.register('text-truncate', TextTruncateController)
application.register('tooltip', TooltipController)
